var _defs, _text, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComprehensiveRelationshipDiagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3, 0 6",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead-blue",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3, 0 6",
    fill: "#1976d2"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead-green",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3, 0 6",
    fill: "#388e3c"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 30,
    fontSize: 22,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#333"
  }, "\n    Entity Deduplication - All Relationship Types\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "one-to-one-section"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 860,
    height: 180,
    fill: "#fff9e6",
    stroke: "#ffa000",
    strokeWidth: 2,
    rx: 8
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 85,
    fontSize: 16,
    fontWeight: "bold",
    fill: "#f57c00"
  }, "ONE-TO-ONE (1:1)"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 105,
    fontSize: 12,
    fill: "#666"
  }, "Each person has exactly one canonical record"), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 125,
    width: 150,
    height: 50,
    fill: "#bbdefb",
    stroke: "#1976d2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 145,
    fontSize: 13,
    textAnchor: "middle",
    fill: "#333"
  }, "Person Record"), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 162,
    fontSize: 11,
    textAnchor: "middle",
    fill: "#666"
  }, "\"John Smith\""), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 125,
    width: 150,
    height: 50,
    fill: "#1976d2",
    stroke: "#0d47a1",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 145,
    fontSize: 13,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "Canonical Person"), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 162,
    fontSize: 11,
    textAnchor: "middle",
    fill: "white"
  }, "ID: P001"), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 125,
    width: 150,
    height: 50,
    fill: "#bbdefb",
    stroke: "#1976d2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 145,
    fontSize: 13,
    textAnchor: "middle",
    fill: "#333"
  }, "Person Record"), /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 162,
    fontSize: 11,
    textAnchor: "middle",
    fill: "#666"
  }, "\"Jane Doe\""), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 125,
    width: 150,
    height: 50,
    fill: "#1976d2",
    stroke: "#0d47a1",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 775,
    y: 145,
    fontSize: 13,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "Canonical Person"), /*#__PURE__*/React.createElement("text", {
    x: 775,
    y: 162,
    fontSize: 11,
    textAnchor: "middle",
    fill: "white"
  }, "ID: P002"), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 150,
    x2: 270,
    y2: 150,
    stroke: "#e91e63",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 140,
    fontSize: 12,
    fontWeight: "bold",
    fill: "#e91e63"
  }, "1:1"), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 150,
    x2: 700,
    y2: 150,
    stroke: "#e91e63",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 140,
    fontSize: 12,
    fontWeight: "bold",
    fill: "#e91e63"
  }, "1:1"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "many-to-one-section"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 260,
    width: 860,
    height: 230,
    fill: "#e8f5e9",
    stroke: "#388e3c",
    strokeWidth: 2,
    rx: 8
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 285,
    fontSize: 16,
    fontWeight: "bold",
    fill: "#2e7d32"
  }, "MANY-TO-ONE (N:1)"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 305,
    fontSize: 12,
    fill: "#666"
  }, "Multiple duplicate addresses resolve to one master address"), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 325,
    width: 150,
    height: 45,
    fill: "#fff3e0",
    stroke: "#f57c00",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 343,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Address Duplicate 1"), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 358,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"123 Main St\""), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 380,
    width: 150,
    height: 45,
    fill: "#fff3e0",
    stroke: "#f57c00",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 398,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Address Duplicate 2"), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 413,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"123 Main Street\""), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 435,
    width: 150,
    height: 45,
    fill: "#fff3e0",
    stroke: "#f57c00",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 453,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Address Duplicate 3"), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 468,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"123 Main St.\""), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 375,
    width: 160,
    height: 60,
    fill: "#f57c00",
    stroke: "#e65100",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 398,
    fontSize: 14,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "Master Address"), /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 418,
    fontSize: 11,
    textAnchor: "middle",
    fill: "white"
  }, "\"123 Main Street\""), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 347,
    x2: 290,
    y2: 390,
    stroke: "#388e3c",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-green)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 402,
    x2: 290,
    y2: 405,
    stroke: "#388e3c",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-green)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 457,
    x2: 290,
    y2: 420,
    stroke: "#388e3c",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-green)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 390,
    fontSize: 13,
    fontWeight: "bold",
    fill: "#388e3c"
  }, "N:1"), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 325,
    width: 150,
    height: 45,
    fill: "#e1bee7",
    stroke: "#7b1fa2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 343,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Org Duplicate 1"), /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 358,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"ABC Corp\""), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 380,
    width: 150,
    height: 45,
    fill: "#e1bee7",
    stroke: "#7b1fa2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 398,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Org Duplicate 2"), /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 413,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"ABC Corporation\""), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 435,
    width: 150,
    height: 45,
    fill: "#e1bee7",
    stroke: "#7b1fa2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 453,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Org Duplicate 3"), /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 468,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"ABC Inc.\""), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 375,
    width: 160,
    height: 60,
    fill: "#7b1fa2",
    stroke: "#4a148c",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 398,
    fontSize: 14,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "Master Org"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 418,
    fontSize: 11,
    textAnchor: "middle",
    fill: "white"
  }, "\"ABC Corporation\""), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 347,
    x2: 700,
    y2: 390,
    stroke: "#388e3c",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-green)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 402,
    x2: 700,
    y2: 405,
    stroke: "#388e3c",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-green)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 457,
    x2: 700,
    y2: 420,
    stroke: "#388e3c",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-green)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 390,
    fontSize: 13,
    fontWeight: "bold",
    fill: "#388e3c"
  }, "N:1"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "one-to-many-section"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 510,
    width: 860,
    height: 220,
    fill: "#e3f2fd",
    stroke: "#1976d2",
    strokeWidth: 2,
    rx: 8
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 535,
    fontSize: 16,
    fontWeight: "bold",
    fill: "#1565c0"
  }, "ONE-TO-MANY (1:N)"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 555,
    fontSize: 12,
    fill: "#666"
  }, "One master person has multiple associated addresses/contacts"), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 580,
    width: 160,
    height: 60,
    fill: "#1976d2",
    stroke: "#0d47a1",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 603,
    fontSize: 14,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "Master Person"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 623,
    fontSize: 11,
    textAnchor: "middle",
    fill: "white"
  }, "\"John Smith\""), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 565,
    width: 140,
    height: 40,
    fill: "#fff3e0",
    stroke: "#f57c00",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 582,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Home Address"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 596,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"123 Main St\""), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 615,
    width: 140,
    height: 40,
    fill: "#fff3e0",
    stroke: "#f57c00",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 632,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Work Address"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 646,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"456 Office Blvd\""), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 665,
    width: 140,
    height: 40,
    fill: "#fff3e0",
    stroke: "#f57c00",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 682,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Mailing Address"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 696,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"PO Box 789\""), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 595,
    x2: 290,
    y2: 585,
    stroke: "#1976d2",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-blue)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 610,
    x2: 290,
    y2: 635,
    stroke: "#1976d2",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-blue)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 625,
    x2: 290,
    y2: 685,
    stroke: "#1976d2",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 620,
    fontSize: 13,
    fontWeight: "bold",
    fill: "#1976d2"
  }, "1:N"), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 580,
    width: 160,
    height: 60,
    fill: "#7b1fa2",
    stroke: "#4a148c",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 603,
    fontSize: 14,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "Master Party"), /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 623,
    fontSize: 11,
    textAnchor: "middle",
    fill: "white"
  }, "\"ABC Group\""), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 565,
    width: 140,
    height: 40,
    fill: "#e1bee7",
    stroke: "#7b1fa2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 582,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Organization 1"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 596,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"ABC Corp\""), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 615,
    width: 140,
    height: 40,
    fill: "#e1bee7",
    stroke: "#7b1fa2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 632,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Organization 2"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 646,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"ABC Ltd\""), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 665,
    width: 140,
    height: 40,
    fill: "#e1bee7",
    stroke: "#7b1fa2",
    strokeWidth: 2,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 682,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "Organization 3"), /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 696,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#666"
  }, "\"ABC Holdings\""), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 595,
    x2: 710,
    y2: 585,
    stroke: "#1976d2",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-blue)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 610,
    x2: 710,
    y2: 635,
    stroke: "#1976d2",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-blue)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 625,
    x2: 710,
    y2: 685,
    stroke: "#1976d2",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 685,
    y: 620,
    fontSize: 13,
    fontWeight: "bold",
    fill: "#1976d2"
  }, "1:N"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "legend"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 750,
    width: 860,
    height: 40,
    fill: "#f5f5f5",
    stroke: "#999",
    strokeWidth: 1,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 770,
    fontSize: 12,
    fontWeight: "bold",
    fill: "#333"
  }, "Relationship Types:"), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 770,
    x2: 220,
    y2: 770,
    stroke: "#e91e63",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 774,
    fontSize: 11,
    fill: "#333"
  }, "1:1 (One-to-One)"), /*#__PURE__*/React.createElement("line", {
    x1: 370,
    y1: 770,
    x2: 410,
    y2: 770,
    stroke: "#388e3c",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-green)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 774,
    fontSize: 11,
    fill: "#333"
  }, "N:1 (Many-to-One)"), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 770,
    x2: 620,
    y2: 770,
    stroke: "#1976d2",
    strokeWidth: 3,
    markerEnd: "url(#arrowhead-blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 774,
    fontSize: 11,
    fill: "#333"
  }, "1:N (One-to-Many)"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveRelationshipDiagram);
export default __webpack_public_path__ + "static/media/comprehensive-relationship-diagram.5101ae5acdb06fde2012414d23861055.svg";
export { ForwardRef as ReactComponent };